import type { PageInfo } from "@/components/Pagination/Pagination";

export enum PersonTimelineObjectType {
  NOTE = "NOTE",
  INTERACTION = "INTERACTION"
}

export interface PersonTimelineAuthor {
  id?: string;
  name: string;
}

export interface PersonTimelineRow {
  id: string;
  objectType: PersonTimelineObjectType;
  title: string;
  description?: string | null;
  sourceLabel: string;
  sourcePath?: string | null;
  author?: PersonTimelineAuthor | null;
  occurredAt: string;
  modifiedAt: string;
  isPrivate: boolean;
  isHighlight: boolean;
}

export interface PersonTimelineConnection {
  nodes: PersonTimelineRow[];
  totalCount: number;
  pageInfo: PageInfo;
}

export function canOpenTimelineRow(row: PersonTimelineRow) {
  return !row.isPrivate || !!row.author;
}
